import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4325afb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ResourceTransformation" }
const _hoisted_2 = { style: {"height":"50px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"50px","line-height":"50px","text-align":"center","margin-left":"14px"} }
const _hoisted_4 = { class: "itemModal" }
const _hoisted_5 = { class: "itemModal" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {initEmptyParam} from '@/hooks/useInitParam'
import {useStore} from "@/store";
import dayjs from "dayjs";
import {getListData} from "@/service/main/system";
import localCache from "@/utils/cache";
import {ref} from "vue";
import PageModal from "@/components/PageModal.vue";
import {ElLoading} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'Transformation',
  setup(__props) {

initEmptyParam()
const store = useStore()

const queryParam = {
  timeSlot: [
    dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const getEmp = async () => {
  let empNames = localCache.getCache('empData')
  const userOptions = empNames.map((item: any) => {
    return {title: item.realName, value: item.realName}
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empName'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  let deptList = store.state.login.depts
  const deptOptions = deptList.map((item: any) => {
    return {title: item.name, value: item.id}
  })
  const deptItem = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  deptItem!.options = deptOptions
}
getDept()

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const modalTitle = ref('资源转化')
const dialogVisible1 = ref(false)
const dialogVisible2 = ref(false)
const resourceCount = ref(0)
const openRate = ref(0)
const avgPrice = ref(0)
const performanceRatio = ref(0)

const handleTransformation1 = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  await getListData("/main/resourceTransformation/transformation1", store.state.system.queryInfo).then((res) => {
    resourceCount.value = res.resourceCount
    openRate.value = res.openRate + '%'
    avgPrice.value = res.avgPrice
    performanceRatio.value = res.performanceRatio
    loadingInstance.close()
    dialogVisible1.value = true
  })
}

const handleTransformation2 = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  await getListData("/main/resourceTransformation/transformation2", store.state.system.queryInfo).then((res) => {
    resourceCount.value = res.resourceCount
    openRate.value = res.openRate + '%'
    avgPrice.value = res.avgPrice
    performanceRatio.value = res.performanceRatio
    loadingInstance.close()
    dialogVisible2.value = true
  })
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "resourceTransformation",
      onSortChange: handleSortChange,
      onTransformationClick1: handleTransformation1,
      onTransformationClick2: handleTransformation2
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 50,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.nickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible1.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible1).value = $event)),
        title: "资源转化",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "资 源 总 数：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: resourceCount.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resourceCount).value = $event)),
                    disabled: 1
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "当 月 开 单 率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: openRate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((openRate).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("当月开单总量 / 资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "当月平均单价：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: avgPrice.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((avgPrice).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("当月开单总额 / 当月开单总量")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "业 绩 资 源 比：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: performanceRatio.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((performanceRatio).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("总资源开单量 / 资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible2.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible2).value = $event)),
        title: "资源上表",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "资源上表率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: openRate.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((openRate).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("沟通表数据/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "A细分类占比：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: openRate.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((openRate).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("A细分类/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "B细分类占比：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: avgPrice.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((avgPrice).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("B细分类/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "C细分类占比：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: performanceRatio.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((performanceRatio).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("C细分类/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "D细分类占比：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: performanceRatio.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((performanceRatio).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("D细分类/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "（总开单）在表开单率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: performanceRatio.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((performanceRatio).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("沟通表中开单数/资源总数开单数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "（总资源）在表开单率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "white-bg-input",
                    modelValue: performanceRatio.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((performanceRatio).value = $event)),
                    disabled: 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("沟通表中开单数/资源总数")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})